import styled from "@emotion/styled";
import { Card, Grid } from "@mui/material";

export const DashboardGrid = styled(Grid)`
    display: flex;
    justify-content: center;
    min-width: 0;
`

export const DashboardCard = styled(Card)`
    width: 100%;
    max-width: 400px;
    height: 160px;
    padding: 1.5rem;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    border-radius: 16px;
    transition: box-shadow 0.3s ease-in-out, transform 0.2s ease-in-out;

    &:hover {
        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
        transform: translateY(-2px);
    }

    gap: 1rem;

    div:first-child {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
        min-width: 0;
    }

    div:last-child {
        display: flex;
        align-items: center;
        height: 100%;
        flex-shrink: 0;

        img {
            width: 96px;
            height: 96px;
            object-fit: contain;
        }
    }
`